import styled from 'styled-components'

const Controls = styled.div`
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: auto;
  @media(max-width: 767px) {
    margin-right: auto;
    margin-bottom: 10px;
    margin-left: auto;
    width: 100%;
    justify-content: space-evenly;
  }
`

export default Controls
